import React from 'react';
import './Home.css';
import HeroSection from '../../components/HeroSection/HeroSection';
import ServicesSection from '../../components/ServicesSection/ServicesSection';
import ChairmansMessage from '../../components/ChairmansMessage/ChairmansMessage';
import Gallery from '../../components/Gallery/Gallery';
// import Achievements from '../../components/Achievements/Achievements';
import Departments from '../../components/Departments/Departments';
import CTASection from '../../components/CTASection/CTASection';
import FeedbackSection from '../../components/FeedbackSection/FeedbackSection';
import StatsCounterSection from '../../components/StatsCounterSection/StatsCounterSection';
import COATOFARM from '../../assets/images/igboeze-nigeria-coat-of-arm.png';
import ReportsSection from '../../components/ReportsSection/ReportsSection';
import ApplicationsSection from '../../components/ApplicationsSection/ApplicationsSection';
import Vision from '../Vision/Vision';
import Mission from '../Mission/Mission';
import Posts from '../../components/Posts/Posts';

const Home = () => {
  return (
    <div className="home">
      {/* <div className='home-background-image'>
        <img src={COATOFARM} alt='coat of arm' />
      </div> */}
      <HeroSection />
      <ChairmansMessage />
      <Vision />
      <Mission />
      <ServicesSection />
      <Posts />
      <Gallery />
      <ReportsSection />
      <StatsCounterSection />
      <Departments />
      <ApplicationsSection />
      <CTASection />
      <FeedbackSection />
    </div>
  );
};

export default Home;
